import { TAGButton } from '@aspendental/shared-components-web';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Box, DialogContent, Divider, Skeleton, Typography } from '@mui/material';
import { dialogStyles } from '../SelectLocationDialog.styles';
import { useSchedulingStore } from '@src/store';
import { BffFacility } from 'types/location';
interface IBffLocationsList {
  heartedLocation: string;
  facilitiesData: {
    items: BffFacility[];
  };
  isLoading: boolean;
  toggleHeart: (id: string) => void;
  handleBeffeLocationChange: (location: BffFacility) => void;
}
export default function BffLocationsList({
  heartedLocation,
  facilitiesData,
  isLoading,
  toggleHeart,
  handleBeffeLocationChange
}: IBffLocationsList) {
  const {
    bffFacilities
  } = useSchedulingStore(state => state);
  const itemsToSort = facilitiesData.items?.length > 0 ? facilitiesData.items : bffFacilities;
  const sortedLocations = [...itemsToSort].sort((a, b) => {
    const isAHearted = a.id === heartedLocation;
    const isBHearted = b.id === heartedLocation;
    if (isAHearted && !isBHearted) return -1;
    if (!isAHearted && isBHearted) return 1;
    const nameA = a.name || '';
    const nameB = b.name || '';

    // do we need this?
    if (a.location?.distance && b.location?.distance) {
      return a.location.distance - b.location.distance;
    }
    return nameA.localeCompare(nameB);
  });
  const getDistance = (distance?: number) => {
    // take the distance passed in and round to 1 decimal
    if (distance === undefined) {
      return '';
    }
    return `${distance.toFixed(1)} miles`;
  };
  if (isLoading) {
    return <Box sx={{
      padding: '0 1rem'
    }}>
				<Skeleton data-test-id="skeleton-loader" variant="rounded" height={120} sx={{
        marginBottom: '1rem',
        width: '100%'
      }} />
				<Skeleton data-test-id="skeleton-loader" variant="rounded" height={120} sx={{
        marginBottom: '1rem',
        width: '100%'
      }} />
				<Skeleton data-test-id="skeleton-loader" variant="rounded" height={120} />
			</Box>;
  }
  return <DialogContent sx={dialogStyles.dialogContent} data-test-id="dialog-content" data-sentry-element="DialogContent" data-sentry-component="BffLocationsList" data-sentry-source-file="BffLocationsList.tsx">
			{sortedLocations.length > 0 ? sortedLocations.map((location, index) => <Box key={index} sx={dialogStyles.locationBox} data-test-id={`location-box-${location.code}`}>
						<Box sx={dialogStyles.locationBoxContent}>
							<Typography variant="bodySmallBold" fontWeight="bold" sx={dialogStyles.locationName} data-test-id={`location-name-${location.code}`}>
								<FavoriteIcon sx={dialogStyles.favoriteIcon(location.id === heartedLocation)} onClick={() => toggleHeart(location.id || '')} data-test-id={`favorite-icon-${location.code}`} aria-label={`Heart location ${location.name}`} />
								{location.name}
							</Typography>
							{location.location?.distance && location.location?.distance <= 200 && <Typography variant="bodySmallBook" sx={dialogStyles.locationAddress} data-test-id={`location-name-${location.code}`}>
									{getDistance(location.location?.distance)}
								</Typography>}
						</Box>
						{location.address && <Typography variant="bodySmallBook" sx={dialogStyles.locationAddress} data-test-id={`location-address-${location.code}`}>
								{location.address.address1}
							</Typography>}
						<TAGButton variant="secondaryDefault" sx={dialogStyles.selectButton} size="S" onClick={() => handleBeffeLocationChange(location)} dataTestId={`select-button-${location.code}`} aria-label={`Select location ${location.name}`}>
							Select
						</TAGButton>
						{index < sortedLocations.length - 1 && <Divider sx={dialogStyles.divider} data-test-id={`divider-${location.code}`} />}
					</Box>) : <Typography variant="bodyMediumBook" fontWeight="normal" data-test-id="no-locations-found">
					No locations found
				</Typography>}
		</DialogContent>;
}